import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { useEffect, useState } from 'react';

interface ISimpleToggle {
  option1: string;
  option2: string;
  setState: (isOption1Select: boolean) => void;
  isOption2?: boolean;
}

export const SimpleToggle = (props: ISimpleToggle) => {
  const isDesktop = useIsDesktop();
  const [alignment, setAlignment] = useState<string>(props.option1);

  useEffect(() => {
    if (props.isOption2) setAlignment(props.option2);
    else setAlignment(props.option1);
  }, [props]);

  const toggleChangeHandler = (
    event: React.MouseEvent<HTMLElement>,
    toggleValue: string
  ) => {
    if (toggleValue === null) return;
    setAlignment(toggleValue);
    props.setState(toggleValue === props.option1);
  };

  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={toggleChangeHandler}
      sx={{
        bgcolor: '#fff',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '6px',
        width: '100%',
        minWidth: isDesktop ? '400px' : undefined,
        label: {
          fontSize: '18px',
          fontWeight: '400',
          cursor: 'pointer',
        },
        '&&& .Mui-selected': {
          bgcolor: 'purple2.main',
          color: 'white',
          fontWeight: 700,
        },
      }}
      role='tabpanel'
    >
      <ToggleButton
        value={props.option1}
        sx={{
          width: '100%',
          borderRadius: '6px',
          border: 'none',
          '&:focus': {
            bgcolor: '#081E54 !important',
            color: 'white',
          },
        }}
        role='tab'
      >
        <Typography variant={'body3'}>{props.option1}</Typography>
      </ToggleButton>
      <ToggleButton
        value={props.option2}
        sx={{
          width: '100%',
          borderRadius: '6px',
          border: 'none ',
          '&:focus': {
            bgcolor: '#081E54 !important',
            color: 'white',
          },
        }}
        role='tab'
      >
        <Typography variant={'body3'}>{props.option2}</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
